import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.moduleConfig.name == 'Home')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: "/home",
        class: "nav"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Home",
              text: "Home"
            })
          ])
        ]),
        _: 1
      }))
    : (_ctx.moduleConfig.name == 'Cards')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: "/cards",
          class: "nav"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Carte",
                text: "Carte"
              })
            ])
          ]),
          _: 1
        }))
      : (_ctx.moduleConfig.name == 'News')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/newsFeed",
            class: "nav"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "News",
                  text: "News"
                })
              ])
            ]),
            _: 1
          }))
        : (_ctx.moduleConfig.name == 'Chat')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: "/chat",
              class: "nav"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Chat",
                    text: "Chat"
                  })
                ])
              ]),
              _: 1
            }))
          : (_ctx.moduleConfig.name == 'Clienti')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                to: "/clienti",
                class: "nav"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Clienti",
                      text: "Clienti"
                    })
                  ])
                ]),
                _: 1
              }))
            : (_ctx.moduleConfig.name == 'Piano alimentare')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: "/pianoAlimentare",
                  class: "nav"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Piano alimentare",
                        text: "Piano alimentare"
                      })
                    ])
                  ]),
                  _: 1
                }))
              : (_ctx.moduleConfig.name == 'Corsi')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 6,
                    to: "/corsi",
                    class: "nav"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Corsi",
                          text: "Corsi"
                        })
                      ])
                    ]),
                    _: 1
                  }))
                : (_ctx.moduleConfig.name == 'Assistenza')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 7,
                      to: "/assistenza",
                      class: "nav"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Assistenza",
                            text: "Assistenza"
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : (_ctx.moduleConfig.name == 'Prenotazioni')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 8,
                        to: "/prenotazioni",
                        class: "nav"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Prenotazioni",
                              text: "Prenotazioni"
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : (_ctx.moduleConfig.name == 'Negozio')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 9,
                          to: "/shop",
                          class: "nav"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Negozio",
                                text: "Negozio"
                              })
                            ])
                          ]),
                          _: 1
                        }))
                      : (_ctx.moduleConfig.name == 'Acquisti')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 10,
                            to: "/acquisti",
                            class: "nav"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Acquisti",
                                  text: "Acquisti"
                                })
                              ])
                            ]),
                            _: 1
                          }))
                        : (_ctx.moduleConfig.name == 'Questionari')
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 11,
                              to: "/questionari",
                              class: "nav"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Questionari",
                                    text: "Questionari"
                                  })
                                ])
                              ]),
                              _: 1
                            }))
                          : (_ctx.moduleConfig.name == 'Faq')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 12,
                                to: "/faq/0",
                                class: "nav"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "FAQ",
                                      text: "FAQ"
                                    })
                                  ])
                                ]),
                                _: 1
                              }))
                            : (_ctx.moduleConfig.name == 'Ricettario')
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 13,
                                  to: "/ricettario/0",
                                  class: "nav"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Ricettario",
                                        text: "Ricettario"
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.moduleConfig.name == 'Storico')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 14,
                                    to: "/storico",
                                    class: "nav"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_localized_text, {
                                          localizedKey: "Storico",
                                          text: "Storico"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.moduleConfig.name == 'Profilo')
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 15,
                                      to: "/profile",
                                      class: "nav"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_localized_text, {
                                            localizedKey: "Profilo",
                                            text: "Profilo"
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : (_ctx.moduleConfig.isCustom)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 16,
                                        href: _ctx.moduleConfig.customUrl,
                                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$store.state.openBrowser && _ctx.$store.state.openBrowser(...args))),
                                        class: "nav"
                                      }, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_localized_text, {
                                            localizedKey: _ctx.moduleConfig.customName,
                                            text: _ctx.moduleConfig.customName
                                          }, null, 8, ["localizedKey", "text"])
                                        ])
                                      ], 8, _hoisted_1))
                                    : _createCommentVNode("", true)
}